module.exports = __webpack_public_path__ + "static/media/tick-check-blue.d8ee7268.svg";